import { Box, Text, useColorModeValue } from "@chakra-ui/react";
import * as React from "react";

import { Field, FieldDescription, FieldLabel } from "@/components/ui/field";
import { REPORT_DETAIL_CARD_BORDER } from "../Reports/components/ReportsCardChrome";

const STRATEGY_PRIMARY_FONT = "var(--font-primary)";

const STRATEGY_OVERVIEW_FIELD_LABEL_CLASS =
  "font-[family-name:var(--font-primary)] text-sm font-normal text-[color:var(--brand-tropical-surf)]";

const STRATEGY_OVERVIEW_FIELD_DESC_CLASS =
  "font-[family-name:var(--font-primary)] text-sm font-normal text-gray-500 dark:text-white";

export type StrategyDescriptionPanelProps = {
  description?: string | null;
};

export function StrategyDescriptionPanel(props: StrategyDescriptionPanelProps): React.ReactElement {
  const trimmed = (props.description ?? "").trim();
  const displayText = trimmed || "—";
  const descriptionTextColor = useColorModeValue("gray.500", "white");

  return (
    <Field className="w-full" data-strategy-description-field="">
      <FieldLabel htmlFor="strategy-overview-description" className={STRATEGY_OVERVIEW_FIELD_LABEL_CLASS}>
        Description
      </FieldLabel>
      <FieldDescription className={STRATEGY_OVERVIEW_FIELD_DESC_CLASS}>
        Setup, rules, and constraints for this strategy. Edit via Edit strategy.
      </FieldDescription>
      <Box
        id="strategy-overview-description"
        data-strategy-description-body=""
        flexShrink={0}
        fontSize="sm"
        fontWeight="normal"
        borderWidth="1px"
        borderStyle="solid"
        borderColor={REPORT_DETAIL_CARD_BORDER}
        borderRadius="6px"
        p="12px"
        color={descriptionTextColor}
        w="100%"
        maxH={{ base: "none", md: "min(78vh, 900px)" }}
        overflowY={{ base: "visible", md: "auto" }}
        fontFamily={STRATEGY_PRIMARY_FONT}
        sx={{
          borderColor: `${REPORT_DETAIL_CARD_BORDER} !important`,
          whiteSpace: "pre-wrap",
          wordBreak: "break-word",
        }}
      >
        <Text
          as="div"
          fontSize="sm"
          fontWeight="normal"
          color={descriptionTextColor}
          fontFamily={STRATEGY_PRIMARY_FONT}
          m={0}
        >
          {displayText}
        </Text>
      </Box>
    </Field>
  );
}
